import { useEffect } from 'react'

interface UseModalDynamicHeightProps {
	contentRef: React.RefObject<HTMLDivElement>
	activeModal: string
	isMobileView: boolean
	modalStackLength: number
}

export const useModalDynamicHeight = ({
	contentRef,
	activeModal,
	isMobileView,
	modalStackLength,
}: UseModalDynamicHeightProps) => {
	useEffect(() => {
		if (isMobileView) return

		let resizeObserver: ResizeObserver | null = null
		let mutationObserver: MutationObserver | null = null

		const setupObservers = () => {
			const content = contentRef.current
			if (!content) return

			const updateHeight = () => {
				const modalEl = document.querySelector(
					'ion-modal.custom-modal-wrapper'
				) as HTMLIonModalElement
				const wrapper = modalEl?.shadowRoot?.querySelector('.modal-wrapper') as HTMLElement
				if (!modalEl || !wrapper || !contentRef.current) return
				const contentHeight = contentRef.current.scrollHeight
				requestAnimationFrame(() => {
					wrapper.style.height = `${contentHeight}px`
					wrapper.style.maxHeight = '90vh'
					wrapper.style.position = 'relative'
					wrapper.style.top = 'unset'
					wrapper.style.bottom = 'unset'
					wrapper.style.transition = 'height 0.3s ease'
				})
			}

			resizeObserver = new ResizeObserver(updateHeight)
			resizeObserver.observe(content)

			mutationObserver = new MutationObserver(updateHeight)
			mutationObserver.observe(content, {
				childList: true,
				subtree: true,
				attributes: true,
				characterData: true,
			})

			setTimeout(updateHeight, 0)
		}

		const timeout = setTimeout(setupObservers, 0)

		return () => {
			clearTimeout(timeout)
			resizeObserver?.disconnect()
			mutationObserver?.disconnect()
		}
	}, [activeModal, isMobileView, modalStackLength])
}
